import { render, staticRenderFns } from "./LookupProductModel.vue?vue&type=template&id=2057507a&scoped=true"
import script from "./LookupProductModel.vue?vue&type=script&lang=ts"
export * from "./LookupProductModel.vue?vue&type=script&lang=ts"
import style0 from "./LookupProductModel.vue?vue&type=style&index=0&id=2057507a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2057507a",
  null
  
)

export default component.exports